export const navbarHeight = 120;
export const footerHeight = 30;
